<template>
  <!-- دکمه نصب pwa -->
  <PwaModal />
  <!-- دکمه نصب pwa -->


  <body class="g-sidenav-show rtl bg-gray-200">
    <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg overflow-x-hidden">
      <div class="container-fluid">
        <div class="row">
          <div
            class="bg-image login-box col-sm-12 col-md-4 col-sm-6 mb-lg-0 mb-4 d-flex flex-column mt align-items-center bg-gradient-info vh-100 position-sticky"
            style="background-image: url('/img/tanker.jpg');">
            <h1 class="fs-6 bg-light mt-10 py-2 px-3 rounded m-0"> {{
              companyInfoStore?.basicSiteInfos?.companyName || "شرکت باربری فراورده های نفتی" }}
            </h1>

            <div class="mt-5" style="max-width: 350px">
              <hr class="dark horizontal my-0" />
              <router-view></router-view>
            </div>
          </div>
          <div class="col-sm-12 col-md-8 col-sm-6 mb-lg-0 mb-4">
            <NoticeSection :basicSiteInfos="companyInfoStore.basicSiteInfos"
              :companyLogoName="companyInfoStore.companyLogoName" />
            <FooterSection :basicSiteInfos="companyInfoStore.basicSiteInfos" />
          </div>
        </div>
      </div>
    </main>
  </body>
</template>

<script setup>
import NoticeSection from "./NoticeSection.vue";
import FooterSection from "./FooterSection.vue";
import PwaModal from './PwaModal.vue';
import { useSettingStore } from "@/store/adminStore";
import { onMounted } from "vue";


const companyInfoStore = useSettingStore();
onMounted(async () => {
  companyInfoStore.getCompanyInfo();
});


</script>

<style scoped></style>
